import { Component, OnInit, Inject, ViewChild, ElementRef } from '@angular/core';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { FormGroup, FormControl, Validators } from '../../../../../node_modules/@angular/forms';
import { PracticeService } from '../../../services/practice.service';
import { Practice } from '../../../models/practice';
import { CustomValidators } from '../../../lib/customer-validators';
import { environment } from '../../../../environments/environment';
import { AccountService } from 'src/app/services/account.service';

@Component({
  selector: 'app-create-practice',
  templateUrl: './create-practice.component.html',
  styleUrls: ['./create-practice.component.scss']
})
export class CreatePracticeComponent implements OnInit {
  public practiceForm: FormGroup;
  fileData: File = null;
  previewUrl:any = null;
  fileUploadProgress: string = null;
  uploadedFilePath: string = null;
  newFileType:string;
  newImageB64:string;
  @ViewChild('fileInput', {static: false}) fileInput: ElementRef;

  constructor(private account: AccountService, public dialogRef: MatDialogRef<CreatePracticeComponent>,
    @Inject(MAT_DIALOG_DATA) public data:any, private practiceService: PracticeService) {
      this.practiceForm = new FormGroup({
        'name': new FormControl(this.data.practice.name, [Validators.required, CustomValidators.validateTextField]),
        'limited': new FormControl(this.data.practice.limited),
        'deleteLogo': new FormControl(''),
        'newLogo': new FormControl('')

      });
    }

  ngOnInit() {
  }

  cancel(){
    this.dialogRef.close(false);
  }

  submit(){
    if(this.data.practice.id){
      this.update();
    }
    else{
      this.create();
    }
  }

  fileProgress(evt: any) {
    var files = evt.target.files;
    var file = files[0];
    if (files && file) {
      if (!file.type.includes('image')) {
        alert('Only images can be uploaded.');
      }
      this.newFileType=file.type;
      var reader = new FileReader();
      reader.onload =this._handleReaderLoaded.bind(this);
      reader.readAsBinaryString(file);
    }
  }

  private _handleReaderLoaded(readerEvt) {
    var binaryString = readerEvt.target.result;
    this.newImageB64= btoa(binaryString);
    this.previewUrl='data:' + this.newFileType + ';base64, ' + this.newImageB64;
  }

  public resetUploader(){
    this.previewUrl='';
    this.newImageB64='';
    this.newFileType='';
    this.fileInput.nativeElement.value = "";
  }

  create(){
    this.data.practice.name = this.practiceForm.get('name').value;
    this.data.practice.limited = this.practiceForm.get('limited').value;
    this.data.practice.newLogoB64 = this.newImageB64;
    this.data.practice.newLogoType = this.newFileType;

    this.practiceService.createPractice(this.data.practice).subscribe(practice=>{
      if(practice.media && practice.media.url){
        localStorage.setItem('practiceImage', environment.apiEndpoint+'/storage/practices/'+practice.media.url);
      } else {
        localStorage.removeItem('practiceImage');
      }
      this.account.updatePractice();
      this.dialogRef.close(true);
    })
  }

  update(){
    this.data.practice.name = this.practiceForm.get('name').value;
    this.data.practice.limited = this.practiceForm.get('limited').value;
    this.data.practice.deleteLogo = this.practiceForm.get('deleteLogo').value;
    this.data.practice.newLogoB64 = this.newImageB64;
    this.data.practice.newLogoType = this.newFileType;

    this.practiceService.updatePractice(this.data.practice).subscribe(practice=>{
      if(practice.media && practice.media.url){
        localStorage.setItem('practiceImage', environment.apiEndpoint+'/storage/practices/'+practice.media.url+'?v='+Math.random().toString(36).substring(2, 15));
      } else {
        localStorage.removeItem('practiceImage');
      }
      this.account.updatePractice();
      this.dialogRef.close(true);
    })
  }
}
